import React, {memo, useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useInput} from '~/hooks';
import {Col, UiImage, UiText, UiQuestionnaireLayout, UiBox, UiSimpleGrid, UiButton} from '~/components/elements';
import {RootState} from '~/redux/root-reducer';
import {HAIR_LOSS_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {Option} from '~/redux/questionnaires/types';
import {spacing} from '~/utils/theme/spacing';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';

const Questionnaire4Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const currentAnswer = useSelector(
    (state: RootState) =>
      state.questionnaires?.collectData[HAIR_LOSS_TELECONSULTATION_KEYS.IMPORTANT_TREATING_HAIR_LOSS]?.data,
  );
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(
    i => i.key === HAIR_LOSS_TELECONSULTATION_KEYS.IMPORTANT_TREATING_HAIR_LOSS,
  );

  let medicalOptions: Option[] = [];
  if (questionnaire?.options?.length) {
    medicalOptions = questionnaire?.options?.filter(i => i?.value !== 'NONE');
  }

  const {inputs, setInputs, validation} = useInput({
    selectedOption: currentAnswer?.selectedOption || '',
  });

  const onClickOption = (answer: {value: string | number; label: string}) => {
    const {value} = answer;
    setInputs({selectedOption: value});
  };

  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: HAIR_LOSS_TELECONSULTATION_KEYS.IMPORTANT_TREATING_HAIR_LOSS,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: HAIR_LOSS_TELECONSULTATION_KEYS.HAIR_LOSS_MEDICATION_OR_TREATMENT}));
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      disableNext={!inputs.selectedOption}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.mLarge} mt={spacing.medium} />
        <UiText fontSize="xl" fontWeight="bold" mt={spacing.large}>
          {questionnaire?.questions?.default}
        </UiText>
        <Col mt={spacing.small} w="100%">
          {medicalOptions?.map(value => (
            <ScrollToBottomButton
              mt={spacing.small}
              key={`${value.label}-${value.value}`}
              title={value.label}
              variant={inputs.selectedOption === value.value ? 'solid' : 'toggle'}
              onClick={() => onClickOption(value)}
            />
          ))}
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire4Screen;
